import PropTypes from 'prop-types';
import React from 'react';
import { getPurposeLabel } from '../../../../../Sections/labels';
import asSyncChoiceField from '../../../asSyncChoiceField';
import SyncChoiceRow from '../../../Base/Input/SyncChoiceRow';
import SyncInputGroup from '../../../Base/Input/SyncInputGroup';
import { isIdenticalValue } from '../../../equals';
import { getSyncFormModelData } from '../../../form';
import { validateSingleChoiceComplete } from '../../../validation';
import { isConfigItemSelected } from '../../form';

const validatePlatformStairwayPurpose = (value, planValue, liveValue, allValues, meta) => {
    const formModelData = getSyncFormModelData(allValues, meta.name);
    const { purposeGroups, platformStairwayPurpose } = formModelData;
    if (typeof purposeGroups?.platform_stairway === 'undefined' || typeof platformStairwayPurpose === 'undefined') {
        return validateSingleChoiceComplete()(value, planValue, liveValue, allValues, meta);
    }

    const isPlatformStairway = purposeGroups.platform_stairway;
    const isSelected = isConfigItemSelected(value);
    if (!isPlatformStairway && isSelected) {
        return 'Bitte wählen Sie den Verwendungszweck “Podesttreppe” aus.';
    } else if (isPlatformStairway && !isSelected) {
        return 'Bitte wählen Sie eine Podesttreppen-Option aus.'
    }
};

const PlatformStairwayPurposeSyncChoice = (props) => {

    const {
        value: currentFormValue,
        planValue,
        liveValue,
        onChange,
        showIdentical
    } = props;

    const getPurposeValueLabel = (option) => {
        if (!option) {
            return '-';
        }

        return getPurposeLabel(option);
    };

    const isSelected = (value) => {
        return value === currentFormValue;
    };

    const leftValue = planValue;
    const rightValue = liveValue;

    const isIdentical = isIdenticalValue(planValue, liveValue);
    if (isIdentical && !showIdentical) {
        return null;
    }

    return (
        <SyncInputGroup
            label="Podesttreppe"
            subLevel
        >
            <SyncChoiceRow
                leftValue={leftValue}
                rightValue={rightValue}
                renderValue={getPurposeValueLabel}
                onSelect={onChange}
                isSelected={isSelected}
                isIdentical={isIdentical}
                showIdentical={showIdentical}
            />
        </SyncInputGroup>
    );
};

PlatformStairwayPurposeSyncChoice.propTypes = {
    onChange: PropTypes.func.isRequired,
    planValue: PropTypes.string,
    liveValue: PropTypes.string,
    value: PropTypes.any,
    showIdentical: PropTypes.bool
};

export default asSyncChoiceField(PlatformStairwayPurposeSyncChoice, {
    allowNull: true,
    validate: validatePlatformStairwayPurpose
});
